<template>
    <!-- Tags Widget -->
    <div class="card my-4">
        <h5 class="card-header"><i class="fas fa-hashtag"></i> Tags</h5>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                <ul v-for="(tag,index) in tags"  :key="tag.key" v-if="index < limiteT" class="list-unstyled mb-0">
                    <li>
                    <a href="#" @click.prevent="viewPostsFromTag(tag)"><i class="fas fa-hashtag"></i> {{ tag }}</a>
                    </li>
                </ul>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-center">
            <button  @click.prevent="updateLimitationTags()" type="button" class="btn btn-sm btn-outline-secondary">
                Mostrar {{this.limiteT == 5 ? 'mais' : 'menos'}}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                tags: [],
                limiteT: 5
            }
        },
        mounted() {
            this.getTags();
        },
        methods:{
            getTags(){
                this.$Progress.start();
                axios.get('/api/externalTags')
                    .then(response => {
                        this.$Progress.finish();
                        this.tags = response.data;
                    });
            },
            updateLimitationTags(){
                if (this.limiteT == this.tags.length) {
                    this.limiteT = 5
                }else{
                    this.limiteT = this.tags.length
                }
            },
            viewPostsFromTag(data){
                this.$parent.viewPostsFromTag(data);
            },
        }
    }
</script>
